import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/layout/Layout";
import { Spinner } from "./components/ui";

import Login from "./pages/Login";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import Dashboard from "./pages/Dashboard";
import AssetsPage from "./pages/assets/Assets";
import QrScanPage from "./pages/QrScan";
import AssetDetail from "./pages/assets/AssetDetail";
import AssetForm from "./pages/assets/AssetForm";
import LabelsPage from "./pages/Labels";
import StoragePage from "./pages/storage/Storage";
import AdminPage from "./pages/admin/AdminPage";
import FinancePage from "./pages/finance/Finance";
import { MyAssetsPage, EmployeesPage, NotFound } from "./pages/Placeholders";

function RequireAuth({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Spinner className="h-8 w-8" />
      </div>
    );
  if (!isAuthenticated)
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  return children;
}

function PublicOnly({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicOnly>
            <Login />
          </PublicOnly>
        }
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* QR Scan — public, no auth required, no sidebar */}
      <Route path="assets/:id/scan" element={<QrScanPage />} />

      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />

        {/* Assets */}
        <Route path="assets" element={<AssetsPage />} />
        <Route path="assets/new" element={<AssetForm />} />
        <Route path="assets/:id" element={<AssetDetail />} />
        <Route path="assets/:id/edit" element={<AssetForm />} />

        {/* Other */}
        <Route path="my-assets" element={<MyAssetsPage />} />
        <Route path="labels" element={<LabelsPage />} />
        <Route path="storage" element={<StoragePage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="finance" element={<FinancePage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
